<template>
  <div class="current-master__wrap is-active">
    <FreeTime
      v-for="(time, index) in times"
      :time_start="time[0]"
      :time_end="time[1]"
      :time_index="index"
      @click.native="setTime(time)"
      :key="index"
    ></FreeTime>
  </div>
</template>
<script>
import FreeTime from "@/components/FreeTime/FreeTime.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import * as moment from "moment";

export default {
  name: "FreeTimeAll",
  components: {
    FreeTime
  },
  data() {
    return {
      times: []
    };
  },
  computed: {
    ...mapState("client", [
      "serviceInProgress",
      "date",
      "selectedServices",
      "timeRange"
    ])
  },
  methods: {
    ...mapActions("salons", ["fetchMasterAvailableTime"]),
    ...mapMutations("client", ["setServiceInProgressData"]),

    setTime(time) {
      this.$emit('onClickAllow');
      this.setServiceInProgressData({ time });
    },
    compareTime(availableTime, bookedTime) {
        const a = new Date().setHours(...availableTime.split(':').map(i => +i));
        const b = new Date().setHours(...bookedTime.split(':').map(i => +i));
        return a > b;
    }
  },
  watch: {
    serviceInProgress: {
      handler: async function(val, oldVal) {
        const {
          masterId,
          concreteServiceId,
          concreteServiceLevelId,
          optionsIds,
          date
        } = val;
        this.times = await this.fetchMasterAvailableTime({
          masterId,
          serviceId: concreteServiceId,
          date,
          serviceLevelId: concreteServiceLevelId,
          options:optionsIds.join(',')
        });
        this.selectedServices.forEach(element => {
           if (moment(element.date).isSame(val.date)) {
              let avalArr = this.times.filter( time => this.compareTime(time[0], element.time[1] ) || !this.compareTime(time[1], element.time[0]));
              this.times = avalArr;
          }
        });

        var that = this;
        this.times = this.times.filter(e => {
          if (that.timeRange == "morning") {
            return (
              Date.parse(`01/01/2011 ${e[0]}:00`) >
                Date.parse(`01/01/2011 08:59:00`) &&
              Date.parse(`01/01/2011 ${e[0]}:00`) <
                Date.parse(`01/01/2011 12:01:00`)
            );
          } else if (that.timeRange == "day") {
            return (
              Date.parse(`01/01/2011 ${e[0]}:00`) >
                Date.parse(`01/01/2011 11:59:00`) &&
              Date.parse(`01/01/2011 ${e[0]}:00`) <
                Date.parse(`01/01/2011 18:01:00`)
            );
          } else if (that.timeRange == "evening") {
            return (
              Date.parse(`01/01/2011 ${e[0]}:00`) >
                Date.parse(`01/01/2011 17:59:00`) &&
              Date.parse(`01/01/2011 ${e[0]}:00`) <
                Date.parse(`01/01/2011 21:01:00`)
            );
          } else {
            return true;
          }
        });
      },
      deep: true
    }
  },
  async beforeMount() {
    const {
      masterId,
      concreteServiceId,
      concreteServiceLevelId,
      optionsIds,
      date
    } = this.serviceInProgress;
    this.times = await this.fetchMasterAvailableTime({
      masterId,
      serviceId: concreteServiceId,
      date,
      serviceLevelId: concreteServiceLevelId,
      options: optionsIds.join(','),
    });
    this.selectedServices.forEach(element => {
        if ( moment(element.date).isSame(date) ) {
            let avalArr = this.times.filter( time => this.compareTime(time[0], element.time[1] ) || !this.compareTime(time[1], element.time[0]));
            this.times = avalArr;
        }
    });
    var that = this;
    this.times = this.times.filter(e => {
      if (that.timeRange == "morning") {
        return (
          Date.parse(`01/01/2011 ${e[0]}:00`) >
            Date.parse(`01/01/2011 08:59:00`) &&
          Date.parse(`01/01/2011 ${e[0]}:00`) <
            Date.parse(`01/01/2011 12:00:00`)
        );
      } else if (that.timeRange == "day") {
        return (
          Date.parse(`01/01/2011 ${e[0]}:00`) >
            Date.parse(`01/01/2011 11:59:00`) &&
          Date.parse(`01/01/2011 ${e[0]}:00`) <
            Date.parse(`01/01/2011 18:00:00`)
        );
      } else if (that.timeRange == "evening") {
        return (
          Date.parse(`01/01/2011 ${e[0]}:00`) >
            Date.parse(`01/01/2011 17:59:00`) &&
          Date.parse(`01/01/2011 ${e[0]}:00`) <
            Date.parse(`01/01/2011 21:01:00`)
        );
      } else {
        return true;
      }
    });
  }
};
</script>
